module.exports = __webpack_public_path__ + "img/logo.d56367e0.png";